import React from 'react';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import { FiArrowDown, FiArrowUp, FiEdit, FiTrash2 } from 'react-icons/fi';
import styled from 'styled-components';
import { SectionModule } from '../../../../api/models/BibleStudyModule';
import { HorizontalContent } from '../../../core/HorizontalContent';
import { RhButton, RhButtonMode } from '../../../core/RhButton';
import { RhCard } from '../../../core/RhCard';
import { colors, H3, H5 } from '../../../core/Styles';
import { getModuleIcon } from '../../bible-study-form.helper';

type Props = {
  module: SectionModule;
  dragHandleProps?: DraggableProvidedDragHandleProps;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
  /** Triggered when user clicks the whole card */
  onClick?: () => void;
  onReOrderClick?: (dir: 'up' | 'down') => void;
};

export const StudySectionModuleCard = (props: Props) => {
  const Icon = getModuleIcon(props.module.moduleType);
  return (
    <RhCard style={styles.card} mode="module" hoverable={!!props.onClick} onClick={props.onClick}>
      <HorizontalContent
        left={
          <ScriptureInfo>
            <FileThumbnail>
              <Icon fill={colors.primary} fontSize={41} />
            </FileThumbnail>
            <div>
              <Flexed>
                {!!props.module.tag && (
                  <>
                    <H5>{props.module.tag}</H5>
                    <H5>•</H5>
                  </>
                )}
                <H5>{props.module.moduleType === 'qanda' ? 'Q&A' : props.module.moduleType}</H5>
              </Flexed>
              {(props.module.moduleType === 'document' || props.module.moduleType === 'image') && (
                <H3>{props.module.name}</H3>
              )}
              {(props.module.moduleType === 'video' ||
                props.module.moduleType === 'scripture' ||
                props.module.moduleType === 'qanda' ||
                props.module.moduleType === 'audio' ||
                props.module.moduleType === 'text') && <H3>{props.module.title}</H3>}
            </div>
          </ScriptureInfo>
        }
        right={[
          !!props.onDeleteClick && (
            <RhButton
              key="module-del"
              mode={RhButtonMode.subtle}
              prefixIcon={FiTrash2}
              iconSize={18}
              onClick={props.onDeleteClick}
            />
          ),
          !!props.onEditClick && (
            <RhButton
              key="module-edit"
              mode={RhButtonMode.subtle}
              prefixIcon={FiEdit}
              iconSize={18}
              onClick={props.onEditClick}
            />
          ),
          !!props.onReOrderClick && (
            <div className="space-y-1">
              <RhButton
                onClick={() => props.onReOrderClick?.('up')}
                mode={RhButtonMode.subtle}
                prefixIcon={FiArrowUp}
                style={{ padding: 6 }}
              />
              <RhButton
                onClick={() => props.onReOrderClick?.('down')}
                mode={RhButtonMode.subtle}
                prefixIcon={FiArrowDown}
                style={{ padding: 6 }}
              />
            </div>
          ),
          // !!props.dragHandleProps && (
          //   <div key="module-handle" style={{ display: 'flex' }} {...props.dragHandleProps}>
          //     <BsArrowsMove color={colors.lightGrey} size={20} />
          //   </div>
          // ),
        ]}
      />
    </RhCard>
  );
};

const styles = {
  card: { outline: 'none' },
};

const ScriptureInfo = styled.div`
  display: flex;
  align-items: center;
  & > :not(:last-child) {
    margin-right: 20px;
  }
`;

const FileThumbnail = styled.div`
  border-radius: 16px;
  width: 75px;
  height: 75px;
  background-color: ${colors.background};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const Flexed = styled.div`
  display: flex;
  align-items: center;
  & > :not(:last-child) {
    margin-right: 0.5rem;
  }
`;
